<footer class="mj-footer">
  <div class="mj-footer__brand">
    <span class="mj-footer__title">Manjocarn</span>
    <p class="mj-footer__tagline">Guinguette au bord de l'eau</p>
  </div>

  <div class="mj-footer__grid">
    <div class="mj-footer__block">
      <h3>Adresse</h3>
      <p>D115BIS, 82140 Saint-Antonin-Noble-Val</p>
    </div>

    <div class="mj-footer__block">
      <h3>Horaires</h3>
      <ul class="mj-footer__hours">
        <li *ngFor="let slot of hours">
          <span class="mj-footer__hours-day">{{ slot.day }}</span>
          <span class="mj-footer__hours-time">{{ slot.hours }}</span>
        </li>
      </ul>
    </div>

    <div class="mj-footer__block">
      <h3>Contact</h3>
      <a href="tel:+33563682585">05 63 68 25 85</a>
      <a
        href="https://www.instagram.com/manjocarn"
        target="_blank"
        rel="noopener noreferrer"
        >Instagram</a
      >
    </div>

    <div class="mj-footer__block">
      <h3>Navigation</h3>
      <nav class="mj-footer__links">
        <a
          *ngFor="let link of navLinks"
          [routerLink]="['/home']"
          [fragment]="link.id"
          >{{ link.label }}</a
        >
      </nav>
    </div>
  </div>

  <div class="mj-footer__bottom">
    <span>&copy; {{ year }} Manjocarn</span>
  </div>
</footer>
